import React, {useState} from "react";
import "./K2ViewPoints.scss";
import { FiChevronRight } from "react-icons/fi";
import { FaArrowRight } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { Helmet } from "react-helmet";


// Gallery Images
const basePath = "/Pictures/Treks/Challenging/K2"
const galleryImages = [
`${basePath}/k2.jpeg`,
`${basePath}/K2Base.jpg`,
`${basePath}/K2BaseCamp.jpg`,
`${basePath}/K2Basecamptrek.jpeg`,
`${basePath}/K2BaseCampTrek.jpg`,
`${basePath}/K2BaseCampTrekking.jpg`,
`${basePath}/K2camp.jpg`,
`${basePath}/K2Pakistan.jpeg`,
`${basePath}/K2trek.jpeg`,
`${basePath}/K2Trek.jpeg`,

];

const K2ViewPoint = () => {

  const [showGallery, setShowGallery] = useState(false); // State to manage gallery visibility
  const [currentImageIndex, setCurrentImageIndex] = useState(0); // State for the current image index


    const handleNextImage = () => {
    setCurrentImageIndex((prev) => (prev === galleryImages.length - 1 ? 0 : prev + 1));
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prev) => (prev === 0 ? galleryImages.length - 1 : prev - 1));
  };
  return (
    <>
     <div className="k2ViewSlider">
            <Helmet>
        <title>K2 View Point Trek | Blog | World Adventures Tours</title>
        <meta
          name="description"
          content="Experience the breathtaking K2 View Point trek through our detailed blog. Discover stunning landscapes, trekking tips, and real adventure stories."
        />
        <meta property="og:title" content="K2 View Point Trek | Blog | World Adventures Tours" />
        <meta
          property="og:description"
          content="Read our blog about the K2 View Point Trek and immerse yourself in the heart of the Karakoram. A journey of breathtaking beauty and unforgettable memories."
        />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://www.worldadventurestours.com/Blogs/K2ViewPoints" />
      </Helmet>

        <div className="k2ViewBackground" onClick={() => setShowGallery(true)}></div>
        <div className="k2ViewGallary">
          <button onClick={() => setShowGallery(true)}>Gallery</button>
        </div>
        <div className="k2ViewHeading">
          <h1>K2 View Points</h1>
        </div>
      </div>
        <div className="overview-container">
          <h2 className="overview-title">Overview</h2>
    
          <div className="overview-section">
            <h3>K2 View Points</h3>
            <p>
              Experience the breathtaking views of K2, the world’s second-highest mountain, from the K2 View Points in Gilgit-Baltistan, Pakistan. Located in the Baltistan region and Hunza-Nagar area, these viewpoints offer a unique opportunity to witness the majestic K2 from a distance of 100 km, provided there are no intervening mountains or obstacles to block the view.

              From an altitude of 4,200 meters or above, in the surrounding regions within a 100km radius, it is possible to catch breathtaking views of K2. The K2 View Points are accessible via a scenic short drive (20-30 km) followed by a moderate 1-2 day trek.
            </p>
          </div>
          <div className="key-highlights">
            <h3>Key Highlights</h3>
            <ul>
              <li>
                <FiChevronRight />
                Witness stunning views of K2, the world’s second-highest peak.
              </li>
              <li>
                <FiChevronRight />
                Explore the picturesque Baltistan region and Hunza-Nagar area.
              </li>
              <li>
                <FiChevronRight />
                Enjoy panoramic views of the Karakoram range, glaciers, and snow-capped peaks.
              </li>
              <li>
                <FiChevronRight />
                Accessible via a scenic short drive and moderate trek.
              </li>
              <li>
                <FiChevronRight />
                Ideal for trekking enthusiasts, adventure seekers, and nature lovers.
              </li>
            </ul>
          </div>
          <div className="overview-section">
            <h3>Embark on an Unforgettable Adventure</h3>
            <p>
            The K2 View Points offer an unforgettable adventure in the Karakorum range, with its rugged landscape, pristine lakes, and majestic mountains. Whether you’re a seasoned trekker or just starting out, this destination is sure to leave you in awe.
            </p>
          </div>
    
          <div className="who-is-it-for">
            <h3>Key Highlights</h3>
            <ul>
              <li>
                <FaArrowRight />
                Witness stunning views of K2, the world’s second-highest peak.
              </li>
              <li>
                <FaArrowRight />
                Explore lush green valleys and running stream waters
              </li>
              <li>
                <FaArrowRight />
                Accessible via a short drive and moderate trek
              </li>
               <li>
                <FaArrowRight />
                Ideal for trekking, hiking, and adventure activities
              </li>
              <li>
                <FaArrowRight />
                Located in the picturesque Baltistan region of Pakistan
              </li>
            </ul>
          </div>
          <div className="overview-section">
            <h3>K2 The world 2nd highest Mountain</h3>
            <p>
            K2, the world’s second highest mountain, offers breathtaking views from various viewpoints across Baltistan and neighboring regions. Our team of explorers has discovered 13 easily accessible viewpoints by August 2024 and the mission is still on. Our team is dedicated to uncovering new and breathtaking K2 viewpoints from the picturesque meadows (Broq’s) of Gilgit-Baltistan. Reaching these K2 viewpoints is a straightforward adventure, taking just one to three days of hiking from nearby towns. Follow the crystal-clear streams and trek along the picturesque trails (lum) to witness the mesmerizing panorama in a day from Skardu, Shigar, Kharmang and Ghanche. Book your holidays to explore the unexpected with the wonders of Northern Pakistan.            </p>
          </div>
          <div className="who-is-it-for">
            <h3>13 K2 Viewpoints You Won’t Want to Miss</h3>
            <ul>
              <li>
                <FaArrowRight />
                Concordia (The main entrance)
              </li>
              <li>
                <FaArrowRight />
                Karaming Helatano Broq
              </li>
              <li>
                <FaArrowRight />
                Gondogoro La pass
              </li>
               <li>
                <FaArrowRight />
                Sogha Broq Khaplu
              </li>
              <li>
                <FaArrowRight />
                Mashebrum La
              </li>
              <li>
                <FaArrowRight />
                Hushey Hun Broq
              </li>
                            <li>
                <FaArrowRight />
                Kandey Broq/Iqbal touq (Top)
              </li>

                            <li>
                <FaArrowRight />
                Machulu Broq
              </li>
                            <li>
                <FaArrowRight />
                Khaplu Ghanche lake
              </li>
                            <li>
                <FaArrowRight />
                Barah Broq
              </li>
                            <li>
                <FaArrowRight />
                Kharkoh Broq
              </li>
                <li>
                <FaArrowRight />
                Thalley La
              </li>
                <li>
                <FaArrowRight />
               Sermik/Kharmang
              </li>
            </ul>
          </div>
          <div className="overview-section">
            <h3>How to get to K2 View points</h3>
            <p>
            Reaching these K2 viewpoints is a straightforward adventure, taking just one to three days of hiking followed by 20-30kms drive from the nearby towns. Hike through the crystal-clear streams and trek along the picturesque trails (lum) to witness the mesmerising panorama in a day from Skardu, Shigar, Kharmang and Ghanche.
            </p>
          </div>
          <div className="overview-section">
            <h3>Plan your Trip</h3>
            <p>
          Book with us for an unforgettable adventure in Pakistan. With our experienced guides, you’ll have a safe and enjoyable hiking experience. Book your spot today and get ready for an adventure of a lifetime.
            </p>
          </div>
        </div>
              {showGallery && (
                <div className="gallery-modal">
                  <div className="gallery-content">
                    <button className="close-btn" onClick={() => setShowGallery(false)}><ImCross /></button>
                    <button className="prev-btn" onClick={handlePrevImage}>&lt;</button>
                    <img src={galleryImages[currentImageIndex]} alt="Gallery" />
                    <button className="next-btn" onClick={handleNextImage}>&gt;</button>
                  </div>
                </div>
              )}
        </>
  );

};

export default K2ViewPoint;
